import {I18n} from 'aws-amplify/utils';
import {
    Alert,
    Container,
    Title,
} from '@mantine/core';

// FNP-1186 placeholder. The real module is FNP-1193, which replaces this file
// with the page and adds the rest of the module inside this directory.
export const PlaceholderPage = () => {
    return (
        <Container p={'xl'}>
            <Title order={2} mb={'md'}>{I18n.get('Certificates')}</Title>
            <Alert title={I18n.get('Not built yet')}>
                {I18n.get('This module is registered but not yet implemented. It arrives with FNP-1193.')}
            </Alert>
        </Container>
    );
};
